import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSignedInAccount } from '../../contexts/AccountContext';
import { useCatalog } from '../../contexts/CatalogContext';
import { giftCardCheck, ordersToFollow } from '../../utils/accountOrders';
import { OrderStatusCard } from './cards/OrderStatusCard';
import { useFeatures } from '../../hooks/useFeatures';
import { useSkinPlan } from '../../hooks/useSkinPlan';
import { PageTitle } from './PageTitle';
import { SkinPlanCard } from './cards/SkinPlanCard';
import { HomeCareCard } from './cards/HomeCareCard';
import { DiaryTeaser } from './cards/DiaryTeaser';
import { DeliverySection } from './home/DeliverySection';
import { RecentOrders } from './home/RecentOrders';

/**
 * Thuis: alles wat bij je routine hoort. Eerst de routine (met bijvullen per product), dan de
 * levering als er een abonnement loopt, dan de laatste bestellingen. Zonder abonnement staat het
 * aanbod om automatisch bij te vullen pas onderaan.
 */
export function AtHome() {
  const {
    account
  } = useSignedInAccount();
  const {
    productById
  } = useCatalog();
  const features = useFeatures();
  const {
    items,
    shape
  } = useSkinPlan();
  const {
    hash
  } = useLocation();
  const sub = account.subscription;
  const subscribed = features.subscriptions && Boolean(sub && sub.status !== 'gestopt');
  const following = ordersToFollow(account.orders, giftCardCheck(productById)).length > 0;

  // Vanaf het overzicht of een oude link (#levering, #routine): na het tonen naar dat blok.
  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    el?.scrollIntoView({
      block: 'start'
    });
  }, [hash]);
  return <div data-id="element-5836" data-mp="3cz8pcx88n9tw">
      <PageTitle lead={items.length ? 'Je routine, je levering en je bestellingen op één plek.' : 'Wat je thuis gebruikt, bestelt en laat bijvullen.'} data-id="element-5837" data-mp="3i0622uahbbo0" />
      <div className="space-y-14" data-id="element-5838" data-mp="1iolhypjtdbmh">
        {/* Waar is mijn pakket? Ook hier bovenaan, niet alleen op het overzicht. */}
        {following && <OrderStatusCard data-id="element-5839" data-mp="1nnyclwgxfmzm" />}
        <div id="routine" className="scroll-mt-28" data-id="element-5840" data-mp="2qwj0v424kobg">
          {items.length ? <SkinPlanCard data-id="element-5841" data-mp="2qyvq82a7q0yj" /> : <HomeCareCard data-id="element-5842" data-mp="2ly7reufqsftr" />}
        </div>
        {subscribed && <DeliverySection data-id="element-5843" data-mp="2lzsmcl5yy0s5" />}
        <RecentOrders data-id="element-5844" data-mp="2zxpk3kw5sd8e" />
        {features.subscriptions && !subscribed && <DeliverySection data-id="element-5845" data-mp="2zzacb3v03k33" />}
        {features.diary && (items.length > 0 || shape.salon) && <DiaryTeaser data-id="element-5846" data-mp="2uxutzjk7jroe" />}
      </div>
    </div>;
}